import { useTranslation } from "react-i18next";
import Shimmer from "@/components/Shimmer";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import CompanyProfileForm from "@/components/Form/CompanyProfileForm.tsx";
import { useGetCompanyProfile } from "@/requests/hooks/collect.ts";

const CompanyProfile = () => {
  const { t } = useTranslation();

  const { isPending: isGetCompanyProfilePending, data: getCompanyProfileData } =
    useGetCompanyProfile();

  const renderHeader = () => (
    <TypographyContainer>
      <HeaderTextBlock
        align="left"
        featureText={t("settings.companyProfile.feature")}
        headingText={t("settings.companyProfile.heading")}
      />
    </TypographyContainer>
  );

  const renderForm = () => {
    if (isGetCompanyProfilePending) {
      return (
        <>
          <div className="my-20">
            <Shimmer height="25px" width="350px" />
          </div>
          <div className="my-20">
            <Shimmer height="60px" width="400px" />
          </div>
          <div className="my-20">
            <Shimmer height="60px" width="400px" />
          </div>
          <div className="my-20">
            <Shimmer height="60px" width="400px" />
          </div>
          <div className="my-35">
            <Shimmer height="70px" width="400px" />
          </div>
        </>
      );
    }

    return (
      <CompanyProfileForm
        companyProfile={getCompanyProfileData}
        isCompanyProfilePending={isGetCompanyProfilePending}
      />
    );
  };

  return (
    <div>
      {renderHeader()}
      {renderForm()}
    </div>
  );
};

export default CompanyProfile;
